module.exports = __webpack_public_path__ + "img/logo_2.957c1e10.png";